import React from 'react'
import {
  NudistaBold14,
  NudistaBold16,
  NudistaBoldCustomFont,
  NudistaMedium12,
  NudistaMedium14,
  NudistaSemiBold11,
  RobotoMedium14,
} from '../Common/Fonts'
import { SearchInput } from '../Common/CommonStyle'
import { P } from '../Common/CommonStyle'
import styled from 'styled-components'

import {
  UserProfilePictureHolder,
  UserProfilePicture,
} from '../Common/CommonStyle'

import {
  Icon,
  SearchFlexDiv,
  SInput,
  RowFlexDiv,
  ColumnFlexDiv,
} from '../Common/CommonStyle'
import {
  NudistaMedium16,
  NudistaMedium11,
  NudistaSemiBold16,
  NudistaMedium9,
} from '../Common/Fonts'
import OnlineStatus from '../Common/OnlineStatus'

const assignments = [
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '1',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '2',
  },
  {
    icon: '/images/navbar/add_2.svg',
    name: 'Holmes, Kate',
    id: '3',
  },
]

const BuildingDesc = () => {
  return (
    <RowFlexDiv
      width='100%'
      height='170px'
      justifyContent='space-between'
      gap='8px'
      backgroundColor='rgba(165, 139,201, 0.16)'
    >
      <ColumnFlexDiv width='25%' height='100%' position='relative'>
        <Icon
          width='100%'
          height='100%'
          src='/images/mainView/assignmentsView/BuildingImage.jpg'
        ></Icon>
        <OnlineStatus marginLeft={'90%'} marginTop={'5%'} />
      </ColumnFlexDiv>

      <ColumnFlexDiv
        // justifyContent='space-between'
        gap='12px'
        width='50%'
        height='90%'
        margin='5% 0% 5% 2%'
        padding='2%'
      >
        <RowFlexDiv justifyContent='flex-start' gap='4px'>
          <Icon
            width='52px'
            height='52px'
            alignSelf='flex-start'
            src='/images//mainView/assignmentsView/company-logo@2x.png'
            alt='facebook_icon'
          />
          <RobotoMedium14>National General Insurance</RobotoMedium14>
        </RowFlexDiv>
        <ColumnFlexDiv gap='4px'>
          <NudistaMedium16 color='primary'> NI283929123</NudistaMedium16>
          <NudistaBoldCustomFont fontSize='19px' Color='Black'>
            Big Corp. Building
          </NudistaBoldCustomFont>
          <NudistaMedium16 color='primary'>
            525 NE North Ave, Atlanta, GA 30308
          </NudistaMedium16>
          <NudistaBold14 color='Black'>
            23 storys, 22bds, 12 ba, 6,254 sqft
          </NudistaBold14>
        </ColumnFlexDiv>
      </ColumnFlexDiv>

      <ColumnFlexDiv
        justifyContent='space-between'
        alignItems='flex-end'
        width='30%'
        height='65%'
        margin='0% 5% 2% 0px'
      >
        <RowFlexDiv gap='10px'>
          <NudistaMedium14 color='grey'>22/12/21</NudistaMedium14>
          <Icon
            width='4px'
            height='15px'
            alignSelf='flex-start'
            opacity='0.28'
            src='/images//mainView/assignmentsView/three-dots.svg'
            alt='facebook_icon'
          />
        </RowFlexDiv>

        <RowFlexDiv>
          {assignments?.map((value, id) => (
            <UserProfilePictureHolder
              width='35px'
              height='35px'
              marginLeft='-5px'
              key={value.id}
            >
              <UserProfilePicture
                width='40px'
                alt='Holmes, Kate'
                src={value.icon}
              />
            </UserProfilePictureHolder>
          ))}
        </RowFlexDiv>
      </ColumnFlexDiv>
    </RowFlexDiv>
  )
}

export default BuildingDesc
